import type Highcharts from 'highcharts';

/**
 * Options every deterioration-model chart starts from. Spread into each chart's
 * options object rather than applied with Highcharts.setOptions, which would
 * change the shared Highcharts instance for other apps in the shell as well.
 *
 * Highcharts draws a "Highcharts.com" credit link on every chart unless it is
 * disabled. Before this, only the survival-curve chart turned it off, and the
 * other seven showed the watermark. Keeping the setting here means a new chart
 * picks it up by starting from these defaults.
 */
export const baseChartOptions: Highcharts.Options = {
	credits: { enabled: false },
};
